var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseModal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 0.614271C16.88 0.0942711 16.04 0.0942711 15.52 0.614271L8.99996 7.12094L2.47996 0.600938C1.95996 0.0809375 1.11996 0.0809375 0.599961 0.600938C0.079961 1.12094 0.079961 1.96094 0.599961 2.48094L7.11996 9.00094L0.599961 15.5209C0.079961 16.0409 0.079961 16.8809 0.599961 17.4009C1.11996 17.9209 1.95996 17.9209 2.47996 17.4009L8.99996 10.8809L15.52 17.4009C16.04 17.9209 16.88 17.9209 17.4 17.4009C17.92 16.8809 17.92 16.0409 17.4 15.5209L10.88 9.00094L17.4 2.48094C17.9066 1.97427 17.9066 1.12094 17.4 0.614271Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/close-modal.9ddce92277e5181b49d83eb56a1e9782.svg";
export { ForwardRef as ReactComponent };